;(function() {
  'use strict'

  angular.module('core.compileHtml', [])
})()
